import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';

import { ColumnFragment } from './ColumnFragmentGql';

export const ColumnDetailsQueryGql: DocumentNode = gql`
query ColumnDetailsQuery($columnId: ID!) {
  columns(filter: { id: $columnId }) {
    ...ColumnFragment
    tags {
      name
    }

  }
}
${ColumnFragment}
`;
